import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { EmptyLayoutComponent } from './core/layouts/empty/empty-layout.component';
import { DynamicLayoutComponent } from './core/layouts/dynamic/dynamic-layout.component';

import { routes as authenticationRoutes } from './authentication/authentication.module';

import { routes as tablesRoutes } from './tables/tables.module';


const routes: Routes = [
  // Redirect empty path and '/iq' to 'iq/personality'
  { path: '', redirectTo: 'cognitive', pathMatch: 'full' },
  { path: 'cognitive', redirectTo: 'cognitive/chat', pathMatch: 'full' },
 

  // Use EmptyLayoutComponent for routes like authentication (footprints)
  {
    path: '',
    component: EmptyLayoutComponent,
    children: [
      {
        path: 'cognitive',
        children: authenticationRoutes
      }
    ]
  },

  // Use DynamicLayoutComponent for main application routes
  {
    path: '',
    component: DynamicLayoutComponent,
    children: [

      {
        path: 'records',
        children: tablesRoutes
      },
      {
        path: 'cognitive',
        children: authenticationRoutes
      }
    ]
  },

  // Redirect all unknown routes to 'iq/personality'
  { path: '**', redirectTo: 'cognitive', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
